// extracted by mini-css-extract-plugin
module.exports = {"video":"video_card_video__WO28H","button":"video_card_button__DwpkZ","videoContainer":"video_card_videoContainer__wNF5y","fullScreen":"video_card_fullScreen__0Ykft"};